module.exports = __webpack_public_path__ + "img/messenger.cf5a34d5.svg";